import React from 'react';
import {RouteModel} from "./models/route-model";
import {RouterComposer} from "./router-composer";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ROUTE_NAMES} from "../../consts";
import type {RedirectModel} from "./models/redirects/redirect-model";
import {Navigate, Route, Routes} from "react-router-dom";

export class RouterProps extends BaseProps {
  routes: Array<RouteModel>;
  redirectRoutes: Array<RouteModel>;
  className: String;
  for: ROUTE_NAMES;
}

export const Router = RouterComposer((props: RouterProps) => {
  return (
    <Routes>
      {
        props.redirectRoutes?.map((redirect: RedirectModel) => (
          <Route
            key={redirect.name}
            path={redirect.from} // Make sure you provide the 'from' path
            element={<Navigate to={redirect.to} replace/>} // Redirect to the 'to' path
          />
        ))
      }
      {
        props.routes?.flatMap((route: RouteModel) =>
          (route.paths ? route.paths : [route.path]).map((path) => (
            <Route path={path} element={<route.Component/>}
                   key={`${route.config.name}-${path}`}>  {/*Unique key for each path*/}
              {
                route.pages?.map(page => {
                  return <Route
                    exact
                    index={page.config.index}
                    path={page.config.path}
                    element={<page.Component/>}
                    key={page.config.name}
                  />
                })
              }
            </Route>
          ))
        )}
    </Routes>
  )
});
